import axios from "axios";
const baseUrl = 'https://compass.tatasteel.com/bff';

//production url
//https://compass.tatasteel.com/bff   


const getAuthentication = (payload, token) => {
    return axios
        .post(baseUrl + "/onlinetc_external", payload, {
            headers: {
                'jwt-token': token
            }
        })
};
const getValidateTcJWTToken = (token) => {
    return axios
        .get(baseUrl + "/generatejwt-onlinetcapi", {
            headers: {
                'jwt-token': token
            }
        }
        )
};  
const getOtpJWTToken = (token) => {
    return axios
        .get(baseUrl + "/generatejwt-onlinetc", {
            headers: {
                'jwt-token': token
            }
        }
        )
};

const sendOtp = (payload, token) => {
    return axios
        .post(baseUrl + "/onlinetc_external", payload, {
            headers: {
                'jwt-token': token
            }
        })
};
export default {
    getValidateTcJWTToken,
    getOtpJWTToken,
    getAuthentication,
    sendOtp
}

